import freshdeskApiService from "@/services/apiBISOM/freshdesk";

const freshworksAuthenticate = async (token: string) => {
  FreshworksWidget("authenticate", {
    token: token,
    callback: await freshdeskApiService.getToken(),
  });
};

export { freshworksAuthenticate };
